module.exports = __webpack_public_path__ + "static/media/criativos_masculino_sapatos.702dbb6b.jpg";